import React, { useState, useEffect } from 'react';
import './ContactUs.css';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { useAnalytics } from '../utils/analytics/useAnalytics';

function ContactUs() {
  const { track } = useAnalytics();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');

  const generateCaptcha = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let captcha = '';
    for (let i = 0; i < 6; i++) {
      captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(captcha);
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    track('form_submit', {
      category: 'Contact',
      label: 'Contact Form'
    });

    if (!validateEmail(email)) {
      alert('Please enter a valid email address.');
      return;
    }
    if (captcha !== captchaInput) {
      alert('CAPTCHA is incorrect. Please try again.');
      return;
    }

    try {
      // Your existing form submission logic here
      
      // Track successful submission
      track('contact_success', {
        category: 'Contact',
        label: 'Contact Form Submission'
      });
      window.location.href = `mailto:hellotearface@gmail.com?subject=Contact Us&body=Name: ${name}%0D%0AEmail: ${email}%0D%0AContact Number: ${phone}%0D%0AMessage: ${message}`;
    } catch (error) {
      // Track failed submission
      track('contact_failure', {
        category: 'Contact',
        label: 'Contact Form Submission',
        error: error.message
      });
    }
  };

  const handleFieldChange = (fieldName) => {
    track('field_change', {
      category: 'Contact',
      label: fieldName
    });
  };

  const handleButtonClick = (buttonName) => {
    track('button_click', {
      category: 'Contact',
      label: buttonName
    });
  };

  useEffect(() => {
    generateCaptcha();
    track('page_view', {
      category: 'Contact',
      label: 'Contact Us Page'
    });
  }, [track]);

  return (
    <>
      <div className="contact-us">
        <div className="contact-section contact-hero-section" id="contact-hero-section">
          <div className="contact-hero-content">
            <div className="contact-hero-text">
              <h1>
                Feedback<span className="contact-comma">,</span><br />
                Matters<span className="contact-dot">.</span>
              </h1>
              <p>
                We want to hear from you. Share your feedback, ideas, or suggestions—
                every message helps us build better products and experiences for everyone.
              </p>
            </div>
            <div className="contact-hero-form">
              <form onSubmit={handleSubmit} className="contact-form">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    handleFieldChange('name');
                  }}
                  required
                />
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    handleFieldChange('email');
                  }}
                  required
                />
                <label htmlFor="phone">Contact Number:</label>
                <PhoneInput
                  country={'us'}
                  value={phone}
                  onChange={(phone) => {
                    setPhone(phone);
                    handleFieldChange('phone');
                  }}
                  inputProps={{
                    name: 'phone',
                    required: true,
                    autoFocus: false,
                  }}
                  containerStyle={{ textAlign: 'left' }}
                  inputStyle={{ width: '100%', textAlign: 'left', color: '#000' }}
                  buttonStyle={{ color: '#000' }}
                />
                <label htmlFor="message">Message:</label>
                <textarea
                  id="message"
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                    handleFieldChange('message');
                  }}
                  required
                />
                <div className="captcha-container">
                  <label htmlFor="captcha">CAPTCHA:</label>
                  <div className="captcha-code">{captcha}</div>
                  <input
                    type="text"
                    id="captcha"
                    value={captchaInput}
                    onChange={(e) => {
                      setCaptchaInput(e.target.value);
                      handleFieldChange('captcha');
                    }}
                    required
                  />
                </div>
                <button type="submit" className="contact-button" onClick={() => handleButtonClick('Contact Us')}>Contact Us</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;